import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { Header } from 'components'
import { useAppContext } from 'contexts/app-context/hooks'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  PrivacyPolicyButtonContainer,
  PrivacyPolicyMenuContainer,
} from '../styles/PrivacyPolicy.styles'

const TermSkeleton = () => {
  const { userSelectedEntity } = useAppContext()

  if (userSelectedEntity === 'BR') {
    return (
      <PrivacyPolicyButtonContainer>
        <Skeleton height="1.5rem" width="8.375rem" />
        <Skeleton height="1.5rem" width="1.5rem" style={{ borderRadius: '50%' }} />
      </PrivacyPolicyButtonContainer>
    )
  }
  return (
    <>
      <PrivacyPolicyButtonContainer>
        <Skeleton height="1.5rem" width="8.375rem" />
        <Skeleton height="1.5rem" width="1.5rem" style={{ borderRadius: '50%' }} />
      </PrivacyPolicyButtonContainer>
      <PrivacyPolicyButtonContainer>
        <Skeleton height="1.5rem" width="8.375rem" />
        <Skeleton height="1.5rem" width="1.5rem" style={{ borderRadius: '50%' }} />
      </PrivacyPolicyButtonContainer>
    </>
  )
}

export const PrivacyPolicyMenuSkeleton: FC<{ title: string }> = ({ title }) => (
  <Page>
    <Header title={title} />
    <PageContent>
      <PrivacyPolicyMenuContainer>
        <TermSkeleton />
      </PrivacyPolicyMenuContainer>
    </PageContent>
  </Page>
)
